module.exports = __webpack_public_path__ + "img/music-work-icon2.be0b4c8e.png";